import { useCallback, useSyncExternalStore } from 'react';

/** Whether a CSS media query matches; re-renders when it changes. */
export function useMediaQuery(query: string) {
  const subscribe = useCallback(
    (onChange: () => void) => {
      const list = matchMedia(query);
      list.addEventListener('change', onChange);
      return () => list.removeEventListener('change', onChange);
    },
    [query],
  );
  return useSyncExternalStore(subscribe, () => matchMedia(query).matches);
}

/** Layout breakpoint: side panel instead of bottom sheet (Tailwind's `md`). */
export const DESKTOP_QUERY = '(min-width: 48rem)';

/** The primary input can hover (a mouse), as opposed to touch screens. */
export const HOVER_QUERY = '(hover: hover) and (pointer: fine)';
